export default "__VITE_ASSET__Dtrcr4JZ__"